import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
const ProjectionDashboard = () => {
  const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
  const sourceDivRef = useRef(null); // Ref for the source div
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [dailyData, setDailyData] = useState({
    employee_count: "",
    presentee_count: "",
    today_leave_count: 0,
    monthly_leave_count: "",
  });
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");
  const [selectedMonthYear1, setSelectedMonthYear1] = useState(null);
  const [selectedToMonthYear2, setSelectedToMonthYear2] = useState();
  const [errors, setErrors] = useState({});
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState({
    present_rate: "0.00%",
    absence_rate: "0.00%",
  });

  const [departmentAttendanceData, setDepartmentAttendanceData] = useState([]);
  const [gross, setGross] = useState([]);

  const [offerLetterStatusCounts, setOfferLetterStatusCounts] = useState({});
  const [offerSentCount, setOfferSentCount] = useState({});
  const currentDateAndTime = () => {
    return new Date().toISOString()?.slice(0, 19).replace("T", " ");
  };

  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
  const currentYear = currentDate.getFullYear();
  const [genderData, setGenderData] = useState([]);
  const [chartOptionsLeave, setChartOptionsLeave] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    present_rate: "0",
    absence_rate: "0",
  });
  const [chartOptionsGross, setChartOptionsGross] = useState([]);

  const [leaveData, setLeaveData] = useState([]);

  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [nextMonthYearOptions, setNextMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);

  const [departmentData, setDepartmentData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptionsfGender, setChartOptionsGender] = useState({});
  const [charAttendenceData, setCharAttendenceData] = useState({});
  const [joiningData, setJoiningData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [chartLocationOptions, setChartLocationOptions] = useState({});
  const [chartEarnedOptions, setChartEarnedOptions] = useState();
  const [departmentEarnedData, setDepartmentEarnedData] = useState();
  const [locationEarnedData, setLocationEarnedData] = useState();
  const [chartEarnedLocOptions, setChartEarnedLocOptions] = useState();
  const [departmentNetData, setDepartmentNetData] = useState();
  const [departmentGrossAndDeductionData, setDepartmentGrossAndDeductionData] =
    useState();
  const [departmentNetSalaryData, setDepartmentNetSalaryData] = useState();
  const [chartNetOptions, setChartNetOptions] = useState();
  const [locationNetData, setLocationNetData] = useState();
  const [chartNetLocOptions, setChartNetLocOptions] = useState();
  const [chartOverTimeOptions, setChartOverTimeOptions] = useState();
  const [departmentOverTimeData, setDepartmentOverTimeData] = useState();
  const [selectMonthOver, setSelectMonthOver] = useState();
  const [selectMonthLocOver, setSelectMonthLocOver] = useState();
  const [chartLocOverTimeOptions, setChartLocOverTimeOptions] = useState();

  const [selectedToMonthYear, setSelectedToMonthYear] = useState();
  const [designationWiseProjecctionSal, setDesignationWiseProjecctionSal] =
    useState([]);
  const [rows, setRows] = useState([]);

  const [selectedNextMonth, setSelectedNextMonth] = useState();
  const [chartProjectionOptions, setChartProjectionOptions] = useState();

  const [visibleDepartments, setVisibleDepartments] = useState(6); // Start with 6 departments
  const [projectionData, setProjectionData] = useState([]);
 
  const offerStatusOptions = [
    { value: "0", label: "Offer Sent" },
    { value: "1", label: "Offer Viewed" },
    { value: "2", label: "Offer Accepted" },
    { value: "3", label: "Offer Rejected" },
    { value: "4", label: "Offer Cancelled" },
    { value: "5", label: "Offer Expired" },
  ];

  
  

  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);

          const splicedData =
            Array.isArray(data.filterData) && data.filterData.length > 0
              ? data.filterData.splice(0, 2)
              : [];

          const fromMonth =
            splicedData.length > 0 ? splicedData[0]?.value : null;

          const toMonth =
            Array.isArray(data.filterData) && data.filterData.length > 1
              ? data.filterData[1]?.value
              : fromMonth;

          setSelectedMonthYear(fromMonth);
          setSelectedToMonthYear(toMonth);

          const selectedMonth = fromMonth;

          
          

          const nextMonth = selectedMonth
            ? getNextMonth(selectedMonth)
            : fromMonth;

          setSelectedMonthYear1(selectedMonth);
          setSelectedToMonthYear2(nextMonth);

          console.log("Selected Month:", selectedMonth);
          console.log("Next Month:", nextMonth);

          setCurrentIndex({
            departmentWiseCountIndex: 0,
            departmentWiseEarnedGrossIndex: 0,
            departmentWiseNetGrossIndex: 0,
            departmentWiseOverTimeHoursIndex: 0,
          });

          if (fromMonth && toMonth) {
          }
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

 
  
  const getProjectionDesignationWiseSalaryData = (selectedMonth, nextMonth) => {
    const headers = apiHeaderJSON;
    setLoading(true);
    axios
      .get(`${apiURL}DashboardRouter/GetDesignationWiseSalaryChange`, {
        params: {
          selected_month_year: selectedMonth,
          next_month_year: nextMonth,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetSalaryProjectionByDesignation =>", data);

        if (response.data.success === true) {
          let designationData = data?.data || [];

          setDesignationWiseProjecctionSal(designationData.length);

          const rows = designationData.map((dept) => ({
            designation_name: dept.designation_name,
            selectedmonth_total_employees: dept.selectedmonth_total_employees,
            nextmonth_total_employees: dept.nextmonth_total_employees,
            previous_avg_salary: dept.previous_avg_salary,
            current_avg_salary: dept.current_avg_salary,
            percentage_change: dept.percentage_change,
            percentage_status: dept.percentage_status,
          }));

          console.log("Mapped Rows: ", rows);

          setRows(rows);
        } else {
          setRows([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise salary data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [selectedToMonth, setSelectedToMonth] = useState(null);

  const [toMonthOptions, setToMonthOptions] = useState([]);

  const getNextMonth = (monthYear) => {
    if (!monthYear) return null;

    const [month, year] = monthYear.split("-").map(Number);
    const date = new Date(year, month - 1);

    date.setMonth(date.getMonth() + 1);

    const nextMonth = `${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${date.getFullYear()}`;
    return nextMonth;
  };

  // const handleSelectedMonthChange = (selectedOption) => {
  //   const selectedValue = selectedOption ? selectedOption.value : null;

  //   if (selectedValue) {
  //     const currentMonthYear = getCurrentMonthYear();
  //     const nextMonth = getNextMonth(selectedValue);

  //     if (
  //       selectedValue === currentMonthYear ||
  //       nextMonth === currentMonthYear
  //     ) {
  //       setSelectedMonthYear(null);
  //       setSelectedNextMonth(null);
  //       setToMonthOptions(
  //         monthYearOptions.filter((option) => option.value !== currentMonthYear)
  //       );
  //       setRows([]);
  //       return;
  //     }

  //     setSelectedMonthYear(selectedValue);
  //     setSelectedNextMonth(nextMonth);

  //     setToMonthOptions(
  //       monthYearOptions.filter(
  //         (option) =>
  //           parseMonthYear(option.value) >= parseMonthYear(selectedValue)
  //       )
  //     );

  //     if (selectedValue && nextMonth) {
  //       getProjectionDesignationWiseSalaryData(selectedValue, nextMonth);
  //     }
  //   } else {
  //     setSelectedMonthYear(null);
  //     setSelectedNextMonth(null);
  //     setToMonthOptions(monthYearOptions);
  //   }
  // };

  // const handleSelectedMonthChange = (selectedOption) => {
  //   const selectedValue = selectedOption ? selectedOption.value : null;
  //   if (selectedValue) {
  //     setSelectedMonthYear(selectedValue);

  //     const nextMonth = getNextMonth(selectedValue);

  //     setSelectedNextMonth(nextMonth);

  //     setToMonthOptions(
  //       monthYearOptions.filter(
  //         (option) =>
  //           parseMonthYear(option.value) >= parseMonthYear(selectedValue)
  //       )
  //     );
  //     if (selectedValue && nextMonth) {
  //       getProjectionDesignationWiseSalaryData(selectedValue, nextMonth);
  //     }
  //   } else {

  //     setSelectedNextMonth(null);
  //     setToMonthOptions(monthYearOptions);
  //   }
  // };

  const handleSelectedMonthChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;

    if (selectedValue) {
      const currentMonthYear = getCurrentMonthYear();
      const nextMonth = getNextMonth(selectedValue); // Get next month based on selection

      // If current month or previous month is selected, reset
      if (
        selectedValue === currentMonthYear ||
        nextMonth === currentMonthYear
      ) {
        setSelectedMonthYear(null);
        setSelectedNextMonth(null);
        setToMonthOptions(monthYearOptions);
        setRows([]); // Empty the rows (no data to show)
        return;
      }

      setSelectedMonthYear(selectedValue);
      setSelectedNextMonth(nextMonth); // Set the next month

      setToMonthOptions(
        monthYearOptions.filter(
          (option) =>
            parseMonthYear(option.value) >= parseMonthYear(selectedValue)
        )
      );

      if (selectedValue && nextMonth) {
        getProjectionDesignationWiseSalaryData(selectedValue, nextMonth);
      }
    } else {
      setSelectedMonthYear(null);
      setSelectedNextMonth(null);
      setToMonthOptions(monthYearOptions);
    }
  };

  
 
  const handleToMonthChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;
    setSelectedToMonth(selectedValue);

    if (selectedValue && selectedMonthYear) {
      const fromMonthDate = parseMonthYear(selectedMonthYear);
      const toMonthDate = parseMonthYear(selectedValue);

      if (fromMonthDate > toMonthDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          to_month:
            "To Month-Year must be greater than or equal to From Month-Year.",
        }));
        return;
      }
    }
  };

  const parseMonthYear = (monthYear) => {
    const [month, year] = monthYear.split("-");
    return new Date(`${year}-${month}-01`);
  };
  const getCurrentMonthYear = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, "0"); 
    const year = now.getFullYear();
    return `${year}-${month}`; 
  };

  const getPreviousMonthYear = (currentMonthYear) => {
    const [year, month] = currentMonthYear.split("-").map(Number);
    const date = new Date(year, month - 1);
    date.setMonth(date.getMonth() - 1);
    const previousMonth = String(date.getMonth() + 1).padStart(2, "0");
    const previousYear = date.getFullYear();
    return `${previousYear}-${previousMonth}`;
  };

  const filterMonthYearOptions = (options) => {
    const currentMonthYear = getCurrentMonthYear();
    const previousMonthYear = getPreviousMonthYear(currentMonthYear);

    return options.filter(
      (option) =>
        option.value !== currentMonthYear && option.value !== previousMonthYear
    );
  };

  
  useEffect(() => {
    getMonthYearOptions();
    getProjectionDesignationWiseSalaryData();
    const sourceDiv = sourceDivRef.current;

    if (sourceDiv) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setTargetDivHeight(`${entry.contentRect.height}px`);
        }
      });

      resizeObserver.observe(sourceDiv);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
    setVisibleDepartments(showMore ? 6 : chartOptions?.labels?.length);
  };
  const renderLabels = (labels) => (labels?.length > 0 ? labels : ["No Data"]);
  const renderSeries = (series) => (series?.length > 0 ? series : [0]);

  const chartOptionsLine = {
    chart: {
      type: "line",
    },
    series: [
      {
        name: "Joins",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    },
    colors: ["#687cfe"],
  };

  const [currentIndex, setCurrentIndex] = useState({
    departmentWiseCountIndex: 0,
    departmentWiseEarnedGrossIndex: 0,
    departmentWiseNetGrossIndex: 0,
    departmentWiseOverTimeHoursIndex: 0,
  });
  const [animationDirection, setAnimationDirection] = useState({
    departmentWiseCountAnimation: "",
    departmentWiseEarnedGrossAnimation: "",
    departmentWiseNetGrossAnimation: "",
    departmentWiseOverTimeHoursAnimation: "",
  });
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [currentIndex3, setCurrentIndex3] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [animating, setAnimating] = useState(false);

  const handlePrev = (type) => {
    if (animating) return;

    if (type === "1") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseCountAnimation: "slide-right",
      });
    } else if (type === "2") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseEarnedGrossAnimation: "slide-right",
      });
    } else if (type === "3") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseNetGrossAnimation: "slide-right",
      });
    } else if (type === "4") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseOverTimeHoursAnimation: "slide-right",
      });
    }
    setAnimating(true);

    setTimeout(() => {
      if (type === "1") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseCountIndex:
            currentIndex?.departmentWiseCountIndex === 0
              ? chartOptions.series.length - 1
              : currentIndex?.departmentWiseCountIndex - 1,
        });
      } else if (type === "2") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseEarnedGrossIndex:
            currentIndex?.departmentWiseEarnedGrossIndex === 0
              ? chartEarnedOptions.series.length - 1
              : currentIndex?.departmentWiseEarnedGrossIndex - 1,
        });
      } else if (type === "3") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseNetGrossIndex:
            currentIndex?.departmentWiseNetGrossIndex === 0
              ? chartNetOptions.series.length - 1
              : currentIndex?.departmentWiseNetGrossIndex - 1,
        });
      } else if (type === "4") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseOverTimeHoursIndex:
            currentIndex?.departmentWiseOverTimeHoursIndex === 0
              ? chartNetOptions.series.length - 1
              : currentIndex?.departmentWiseOverTimeHoursIndex - 1,
        });
      }

      setAnimationDirection({
        departmentWiseCountAnimation: "",
        departmentWiseEarnedGrossAnimation: "",
        departmentWiseNetGrossAnimation: "",
        departmentWiseOverTimeHoursAnimation: "",
      });
      setAnimating(false);
    }, 500);
  };
  const handleNext = (type) => {
    if (animating) return;
    if (type === "1") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseCountAnimation: "slide-left",
      });
    } else if (type === "2") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseEarnedGrossAnimation: "slide-left",
      });
    } else if (type === "3") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseNetGrossAnimation: "slide-left",
      });
    } else if (type === "4") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseOverTimeHoursAnimation: "slide-left",
      });
    }
    setAnimating(true);
    setTimeout(() => {
      if (type === "1") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseCountIndex:
            currentIndex?.departmentWiseCountIndex ===
            chartOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseCountIndex + 1,
        });
      } else if (type === "2") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseEarnedGrossIndex:
            currentIndex?.departmentWiseEarnedGrossIndex ===
            chartEarnedOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseEarnedGrossIndex + 1,
        });
      } else if (type === "3") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseNetGrossIndex:
            currentIndex?.departmentWiseNetGrossIndex ===
            chartNetOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseNetGrossIndex + 1,
        });
      } else if (type === "4") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseOverTimeHoursIndex:
            currentIndex?.departmentWiseOverTimeHoursIndex ===
            chartNetOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseOverTimeHoursIndex + 1,
        });
        setCurrentIndex1((prev) =>
          prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1
        );
      }
      setAnimationDirection({
        departmentWiseCountAnimation: "",
        departmentWiseEarnedGrossAnimation: "",
        departmentWiseNetGrossAnimation: "",
        departmentWiseOverTimeHoursAnimation: "",
      });
      setAnimating(false);
    }, 500);
  };
  console.log("monthYearOptions", monthYearOptions);
  return (
    <div className="card p-2">
      <div className=""></div>
      <div className="row">
        <div className="container"></div>
        <div className="text-center mt-3">
          <h5>Designation Wise Salary Comparison & Trends</h5>
        </div>
        <div className="card-header">
          <div className=" row">
            <div className="col-md-3 position-relative me-2">
              <label htmlFor="selected_Month" className="form-label">
                Selected Month Year:
              </label>
              <div className="position-absolute z-2 w-100">
                <Select
                  id="selected_Month"
                  name="selected_Month"
                  value={
                    selectedMonthYear
                      ? monthYearOptions.find(
                          (option) => option.value === selectedMonthYear
                        )
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleSelectedMonthChange(selectedOption)
                  }
                  options={filterMonthYearOptions(monthYearOptions)}
                  placeholder={"Select Month-Year"}
                />
              </div>
              {errors.selected_Month && (
                <p style={{ color: "red" }}>{errors.selected_Month}</p>
              )}
            </div>

            <div className="col-md-3">
              <div className="">
                <label htmlFor="to_month" className="form-label">
                  Next Month Year:
                </label>
                <Select
                  id="to_month"
                  name="to_month"
                  value={
                    selectedNextMonth
                      ? monthYearOptions.find(
                          (option) => option.value === selectedNextMonth
                        )
                      : null
                  }
                  options={monthYearOptions}
                  onChange={(selectedOption) =>
                    handleToMonthChange(selectedOption)
                  }
                  placeholder={"Next Month-Year"}
                  isDisabled={true}
                />
                {errors.to_month && (
                  <p style={{ color: "red" }}>{errors.to_month}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "75vh", overflowY: "auto", overflowX: "auto" }}
        >
          <table
            style={{ minWidth: "100%" }}
            className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped"
          >
            <thead className="bg-primary text-light bg-gradient sticky-top z-1 ">
              <tr>
                <th>Sr No.</th>
                <th>Designation</th>
                <th>Employees count Of Selected Month</th>
                <th>Employees count Of Next Month</th>
                <th>Selected Month Salary (CTC)</th>
                <th>Next Month Salary (CTC)</th>
                <th>Percentage Rate</th>
              </tr>
            </thead>
            {rows.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan={7}>
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.designation_name}</td>
                    <td className="text-center">
                      {row.selectedmonth_total_employees}
                    </td>{" "}
                    <td className="text-center">
                      {row.nextmonth_total_employees}
                    </td>{" "}
                    <td className="text-center">{row.previous_avg_salary}</td>{" "}
                    <td className="text-center">{row.current_avg_salary}</td>
                    <td className={`text-center text-${row.percentage_status}`}>
                      {row.percentage_change}
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};
export default ProjectionDashboard;
